import { graphql, useStaticQuery } from 'gatsby';

export function formatHomePageContent(homePageContent) {
  return {
    id: homePageContent.id,
    sections: homePageContent.sections_order.map((section) => section.home_page_sections_id.id),
    home: {
      title: homePageContent.home_title,
      subtitle: homePageContent.home_subtitle,
      eligibilityTitle: homePageContent.home_eligibility_title,
      button: homePageContent.home_button,
      contentSize: homePageContent.home_content_size,
      backgroundUrl: homePageContent.home_background && `${process.env.DIRECTUS_URI}assets/${homePageContent.home_background.id}`,
    },
    insurances: {
      pretitle: homePageContent.insurances_pretitle,
      title: homePageContent.insurances_title,
      subtitle: homePageContent.insurances_subtitle,
    },
    service: {
      pretitle: homePageContent.service_pretitle,
      title: homePageContent.service_title,
      subtitle: homePageContent.service_subtitle,
    },
    hiw: {
      pretitle: homePageContent.hiw_pretitle,
      title: homePageContent.hiw_title,
      subtitle: homePageContent.hiw_subtitle,
      steps: homePageContent.hiw_steps.map((step) => ({
        title: step.step_title,
        subtitle: step.step_subtitle,
        description: step.step_description,
        backgroundUrl: `${process.env.DIRECTUS_URI}assets/${step.step_background.key}`,
      })),
    },
    faqQuestions: homePageContent.faq_questions.map((question) => {
      const { title, content } = question.faq_questions_id;

      return {
        title,
        content: content
          .replace(/%prices-(.+?)%/g, '<span class="modal-link prices-link">$1</span>')
          .replace(/%checkEligibility-(.+?)%/g, '<span class="modal-link check-eligibility-link">$1</span>'),
      };
    }),
    aboutUs: {
      pretitle: homePageContent.aboutus_pretitle,
      title: homePageContent.aboutus_title,
      subtitle: homePageContent.aboutus_subtitle,
    },
    reviews: {
      pretitle: homePageContent.reviews_pretitle,
      title: homePageContent.reviews_title,
      subtitle: homePageContent.reviews_subtitle,
    },
    press: {
      title: homePageContent.press_title,
    },
  };
}

export default function getDefaultHomePageContent() {
  return useStaticQuery(graphql`
    query {
      directus {
        home_page (filter: { id: { _eq: "default" } }) {
          id,
          sections_order {
            home_page_sections_id {
              id
            }
          },
          header_items,
          home_title,
          home_subtitle,
          home_eligibility_title,
          home_button,
          home_background {
              id
          },
          home_content_size,
          insurances_pretitle,
          insurances_title
          insurances_subtitle,
          service_pretitle,
          service_title,
          service_subtitle,
          hiw_pretitle,
          hiw_title,
          hiw_subtitle,
          hiw_steps,
          faq_questions {
            faq_questions_id {
              title,
              content
            }
          },
          aboutus_pretitle,
          aboutus_title,
          aboutus_subtitle,
          reviews_pretitle,
          reviews_title,
          reviews_subtitle,
          press_title
        }
      }
    }
  `).directus.home_page[0];
}
